import CustomHttpClient from '../customHttpClient';

import { getError } from '../../utils';
import userHelper from '../../utils/userHelper';

import {
  CarPossessionsServiceResponse,
  LifePossessionsServiceResponse,
  Possessions,
  PossessionsServiceResponse,
  UserInformation,
  VariousRiskPossessionsServiceResponse,
  VesselsPossessionsServiceResponse,
} from '../../interfaces';

export interface PossessionsServiceParams {
  rama: string;
  poliza: string;
  articulo: string;
  superpoliza: string;
}

const mapPossessionsResponse = (
  possessionsList: Array<Possessions>
): PossessionsServiceResponse => ({
  possessions: possessionsList,
});

const getUserInfo = () => {
  const {
    codigoDeEmpresa,
    codigoDeSucursal,
    intermediarioPrincipal,
    intermediarioSecundario,
  }: UserInformation = userHelper.getUser()!;

  return {
    empresa: codigoDeEmpresa,
    sucursal: codigoDeSucursal,
    nivt: intermediarioSecundario?.nivelInter,
    nivc: intermediarioSecundario?.codigoInter,
    nit1: intermediarioPrincipal?.nivelInter,
    niv1: intermediarioPrincipal?.codigoInter,
  };
};

const customHttpClient = CustomHttpClient({ baseUrl: 'productores' });

const PossessionsService = {
  async getCarPossessions(
    policeData: PossessionsServiceParams
  ): Promise<PossessionsServiceResponse> {
    const url = 'obtenerBienesAutos';
    const params = { ...getUserInfo(), ...policeData };

    try {
      const response =
        await customHttpClient.get<CarPossessionsServiceResponse>(url, {
          params,
        });
      const formattedResponse = mapPossessionsResponse(response.data.vehiculos);

      return formattedResponse;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getVesselsPossessions(
    policeData: PossessionsServiceParams
  ): Promise<PossessionsServiceResponse> {
    const url = 'obtenerBienesEmbarcaciones';
    const params = { ...getUserInfo(), ...policeData };

    try {
      const response =
        await customHttpClient.get<VesselsPossessionsServiceResponse>(url, {
          params,
        });
      const formattedResponse = mapPossessionsResponse(
        response.data.embarcaciones
      );

      return formattedResponse;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getVariousRiskPossessions(
    policeData: PossessionsServiceParams
  ): Promise<PossessionsServiceResponse> {
    const url = 'obtenerBienesRiesgosVarios';
    const params = { ...getUserInfo(), ...policeData };

    try {
      const response =
        await customHttpClient.get<VariousRiskPossessionsServiceResponse>(url, {
          params,
        });
      const formattedResponse = mapPossessionsResponse(
        response.data.ubicaciones
      );

      return formattedResponse;
    } catch (error) {
      throw new Error(getError(error));
    }
  },

  async getLifePossessions(
    policeData: PossessionsServiceParams
  ): Promise<PossessionsServiceResponse> {
    const url = 'obtenerBienesVida';
    const params = { ...getUserInfo(), ...policeData };

    try {
      const response =
        await customHttpClient.get<LifePossessionsServiceResponse>(url, {
          params,
        });
      const formattedResponse = mapPossessionsResponse(
        response.data.bienesVida
      );

      return formattedResponse;
    } catch (error) {
      throw new Error(getError(error));
    }
  },
};

export default PossessionsService;
